module.exports = __webpack_public_path__ + "img/bar-chart.c270d0d2.svg";